import React from 'react';
import styled from 'styled-components';
import { getIn } from 'seamless-immutable';
import { withCookies } from '@catalogo/core-connect/cookies';
import SoldAndDelivered from '@catalogo/ui-americanas-mobile-offers-box/src/sold-and-delivered';
import InternationalMessage from './international-message';
import MoreOffers from './more-offers';

export const OffersBox = ({ routeId, currentSku, product }) => {
  const offersQuantity = getIn(currentSku, ['offers', 'meta', 'total'], 0);
  const isInternational = getIn(currentSku, ['offers', 'result', '0', 'currency']) === 'USD';
  const hasMoreOffers = offersQuantity > 1;

  return (
    <Wrapper>
      <SoldAndDelivered routeId={routeId} currentSku={currentSku} isDigital={product?.isDigital} />
      {isInternational && <InternationalMessage />}
      {hasMoreOffers && <MoreOffers offersQuantity={offersQuantity - 1} currentSku={currentSku} product={product} />}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  padding: 20px 0 30px 0;
  font-size: 14px;
  background: #fff;
  color: #666;
`;

export default withCookies(OffersBox);
